import * as connectedReactRouter from 'connected-react-router'
import routes from '../../../config/routes'
import * as types from './types'
import * as alerts from '../alerts'
import * as integration from '../../../integration'

export const fetchAcceptTerm = (value = true) => ({
  type: types.FETCH_ME_ACCEPT_TERM,
  payload: value
})

export const receiveAcceptTerm = () => ({
  type: types.RECEIVE_ME_ACCEPT_TERM
})

export const acceptTerm = () => async (dispatch, getState) => {
  dispatch(fetchAcceptTerm())

  try {
    const { acceptedCommitmentTermAt, acceptedResponsibilityTermAt } =
      getState().currentUserReducer

    if (!acceptedCommitmentTermAt) {
      await integration.resources.me.requests.acceptTerm(1)
    }

    if (!acceptedResponsibilityTermAt) {
      await integration.resources.me.requests.acceptTerm(2)
    }

    dispatch(connectedReactRouter.routerActions.push(routes.wallet.path))

    return true
  } catch (err) {
    alerts.actions.receiveAlert({
      title: 'Erro ao aceitar termos',
      message: 'É possível que seu usuário já tenha aceito os termos',
      action: 'default'
    })

    return Promise.reject()
  }
}
